export const REGEX = {
  // Keep in sync with backend password policy
  password:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d\s])[\x21-\x7E]{8,20}$/,
};

export const PASSWORD_VALIDATION_MESSAGE =
  'Password must be 8-20 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.';
